export type AppearancePreference = "system" | "light" | "dark";
export type ResolvedTheme = Exclude<AppearancePreference, "system">;

export const APPEARANCE_STORAGE_KEY = "curiosity-engine-appearance";

const appearanceOrder: AppearancePreference[] = ["system", "light", "dark"];

export function isAppearancePreference(
  value: string | null,
): value is AppearancePreference {
  return value === "system" || value === "light" || value === "dark";
}

export function resolveAppearance(
  preference: AppearancePreference,
  systemPrefersDark: boolean,
): ResolvedTheme {
  if (preference === "system") {
    return systemPrefersDark ? "dark" : "light";
  }
  return preference;
}

export function getNextAppearance(
  preference: AppearancePreference,
  resolvedTheme: ResolvedTheme,
): AppearancePreference {
  if (preference === "system") {
    return resolvedTheme === "dark" ? "light" : "dark";
  }
  const currentIndex = appearanceOrder.indexOf(preference);
  return appearanceOrder[(currentIndex + 1) % appearanceOrder.length];
}

export function applyAppearance(
  preference: AppearancePreference,
  resolvedTheme: ResolvedTheme,
) {
  document.documentElement.dataset.appearance = preference;
  document.documentElement.dataset.theme = resolvedTheme;
  document.documentElement.style.colorScheme = resolvedTheme;
  document
    .querySelector<HTMLMetaElement>('meta[name="theme-color"]')
    ?.setAttribute("content", resolvedTheme === "dark" ? "#090b10" : "#eef1f8");
}
